<template>
    <div class="row">
        <div class="col-md-7 col-sm-7">
            <div class="prod-container product">
                <img class="prod-img" v-bind:src="getProductImage(product)"/>
                <div class="prod-replica">
                    <div class="prod-replica-table">
                        <div class="prod-replica-table-td" v-bind:class="product.ui_classes">
                            <p v-for="n in product.max_lines">{{ lines[n-1] }}</p>
                        </div>
                    </div>
                </div>
                <p class="product-description">
                    * Shown using Frutiger font &amp; {{ product.max_characters }} characters per line.
                </p>
            </div>
        </div>
        <div class="col-md-5 col-sm-5">
            <h3 class="product-size" v-html="product.description"></h3>
            <h4 class="product-price">{{ product.material }}</h4>

            <h3 class="product-inscription">INSCRIPTION</h3>
            <div class="brick-text-form">
                <div v-for="n in product.max_lines" class="form-group row no-gutter">
                    <div class="col-md-2">
                        <label v-bind:for="'l-' + n">Line {{ n }}:</label>
                    </div>
                    <div class="col-md-10">
                        <input class="form-control"
                            v-bind:line-id="'l-' + n"
                            v-on:keydown="withAnyKeyDown($event)"
                            v-on:keyup="withAnyKeyUp($event)"
                            v-on:input="withInput($event)"
                            v-bind:id="'l-' + n"
                            v-bind:value="lines[n-1]"
                            v-bind:maxlength="product.max_characters"
                            v-bind:size="product.max_characters"
                        />
                    </div>
                </div>
            </div>
            <p class="product-description">Need inspiration?
                <a class="text-danger pointer" v-on:click="showInscriptionExamples()">Click here</a>
                for inscription examples.
            </p>
        </div>
    </div>
</template>

<script>
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import InscriptionEditMixin from '../../../../../assets/js/components/frontend/mixin/inscription-edit.vue'
    import InscriptionHandlingMixin from '../mixin/inscription-handling.vue'
    export default {
        name: 'VirtualBrick',
        mixins: [
            InscriptionEditMixin,
            InscriptionHandlingMixin
        ],
        data: function () {
            return this.getDefaultData();
        },
        props: {
            product: {
                type: Object,
                required: true
            }
        },
        methods: {
            getDefaultData: function () {
                return {
                    default_max_characters: 16,
                    lines: {
                        // index: text
                    }
                }
            },
            showInscriptionGuidelines: function () {
                Event.$emit(
                    'inscriptionGuidelinesPopup',
                    { max_chars: this.product.max_characters || this.default_max_characters }
                );
            },
            showInscriptionExamples: function () {
                Event.$emit('inscriptionExamplesPopup');
            },
            getProductImage: function (item) {
                return this.baseImagePath + item.item_image_blank;
            }
        },
        computed: {
            campaign: function () {
                return this.$store.state.campaign
            },
            baseImagePath: function () {
                return 'images/catalog/'; // + this.campaign.short_url + '/';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Brick.vue?4c5ee524